<div class="modal z-50 fixed w-screen h-full top-0 left-0 flex items-center justify-center p-5 lg:p-0">
  <div class="modal-overlay fixed w-full h-full bg-gray-900 opacity-50"></div>
  <div
    class="flex items-center bg-chathams-blue w-full lg:max-w-screen-sm mx-auto rounded-lg shadow-xl z-50 overflow-y-auto"
  >
    <div class="bg-gradient-gray p-5 rounded-md outline-none focus:outline-none text-center text-sm text-white">
      <p class="text-base">
        Enviamos um email para <strong class="italic">{{ email }}</strong> para alterar sua senha! Por favor, clique em
        <strong class="italic">"Recuperar Senha"</strong> no corpo do e-mail.
      </p>
      <p class="mt-5">Já se passou 5 minutos e ainda não recebeu o e-mail?</p>
      <ul class="mt-3 px-5 list-disc list-outside text-left">
        <li>Confira a sua conexão na internet;</li>
        <li>Confira se o e-mail não parou na caixa de SPAM;</li>
        <li>Solicite mais um reenvio clicando no botão abaixo.</li>
      </ul>
      <button class="btn mt-5 px-6 py-2 md:px-36 text-white bg-cerise-red rounded-sm" type="button" (click)="resend()">
        Enviar novamente
      </button>
      <div class="mt-6">
        <a routerLink="/login" class="underline font-bold cursor-pointer">Voltar para o Login</a>
      </div>
    </div>
  </div>
</div>
